export enum ColumnInputType {
  Text = 0,
  Number = 1,
  Dropdown = 2,
  Checkbox = 3,
  Custom = 4,
  MultiDropdown = 5,
  DateTime = 6,
}
